import { Link, NavLink } from "react-router-dom";
import "./appHeader.scss";

const AppHeader = () => {
    return (
        <header>
            <div className="header">
                <h1 className="header__title">
                    <Link to="/">
                        Marvel
                        <span className="header__title-span">
                            information portal
                        </span>
                    </Link>
                </h1>
                <div className="header__menu">
                    <NavLink
                        style={({ isActive }) => ({
                            color: isActive ? "#9f0013" : "inherit",
                        })}
                        to="/"
                        end
                    >
                        <p className="header__menu-characters">Characters</p>
                    </NavLink>
                    <span className="header__menu-slash">/</span>
                    <NavLink
                        style={({ isActive, isPending }) => ({
                            color:
                                isActive || isPending ? "#9f0013" : "inherit",
                        })}
                        to="/comics"
                        end={false}
                    >
                        <p
                            style={{ color: "inherit" }}
                            className="header__menu-comics"
                        >
                            Comics
                        </p>
                    </NavLink>
                </div>
            </div>
        </header>
    );
};

export default AppHeader;
